import React, {
  ChangeEvent, FocusEvent, useEffect, useRef, useImperativeHandle, RefObject,
} from 'react';

import { StyledTextarea } from './styles';

interface ITextareaProps {
  className?: string;
  value: string;
  isInvalid?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  inputRef?: RefObject<HTMLTextAreaElement>;
}

export const Textarea = ({
  className,
  value,
  isInvalid = false,
  disabled = false,
  placeholder,
  onChange,
  onBlur,
  inputRef,
}: ITextareaProps) => {
  const controlRef = useRef<HTMLTextAreaElement>(null);

  // weird typing of react, forces ref to be nullish but forbids forward ref to be nullish
  useImperativeHandle(inputRef, () => {
    return controlRef.current as HTMLTextAreaElement;
  });

  useEffect(() => {
    if (controlRef && controlRef.current) {
      controlRef.current.style.height = '0px';
      const { scrollHeight } = controlRef.current;
      controlRef.current.style.height = `${scrollHeight + 2}px`;
    }
  }, [value]);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value.trimStart());
  };

  const handleBlur = (event: FocusEvent<HTMLTextAreaElement>) => {
    if (!onBlur) {
      return;
    }

    onBlur(event.target.value.trimStart());
  };

  return (
    <StyledTextarea
      className={className}
      ref={controlRef}
      value={value}
      placeholder={placeholder}
      isInvalid={isInvalid}
      disabled={disabled}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
